module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-1.8395fc8a.mp3";